import styled from 'styled-components'
import { Skeleton, Text, useTooltip, HelpIcon, Flex, Box, useMatchBreakpoints } from '@pancakeswap/uikit'
import Balance from 'components/Balance'
import BaseCell, { CellContent } from './BaseCell'
import { useLocation } from 'react-router-dom'
import { ethers } from 'ethers'
import { useWeb3React } from '@web3-react/core'

interface AutoEarningsCellProps {
  pool: any
  account: string,
  price?: any
}

const StyledCell = styled(BaseCell)`
  /* flex: 4.5; */
  /* width:110px; */
  ${({ theme }) => theme.mediaQueries.sm} {
    flex: 1 0 80px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
     /* flex:1; */
     padding-right: 75px;
  }
  ${({ theme }) => theme.mediaQueries.md} {
     /* flex:1; */
     /* width:230px; */
     min-width:150px;
     padding-right: 75px;
  }
  ${({ theme }) => theme.mediaQueries.xl} {
     /* flex:1; */
     min-width:150px;
     padding-right: 75px;
  }
`

const HelpIconWrapper = styled.div`
  align-self: center;
`

const AutoEarningsCell: React.FC<AutoEarningsCellProps> = ({ pool, account, price }) => {

  const location = useLocation();
  const { isMobile } = useMatchBreakpoints()
  const { earningTokenPrice } = pool

  const labelText = ` Earned`
  const { error, connector, activate, deactivate, library, active } = useWeb3React();    
  return (


    <StyledCell role="cell">
      {location.pathname === '/farm' ?

        <>

          <Text fontSize="12px" color="#00FED9" textAlign="left">
            {labelText}
          </Text>
          <Balance
            display="inline"
            fontSize={isMobile ? '14px' : '16px'}
            color="white"
            decimals={2}
            prefix=""
            textTransform='uppercase'
            value={pool.user && pool?.lpTokenDecimal ? parseFloat(ethers.utils.formatUnits(pool.user?.pendingreward, 18).toString()) : 0}
            unit=" driven"
          />
          <Balance
            display="inline"
            fontSize="12px"
            color="#B1B3CB"
            decimals={2}
            prefix="~ "
            value={pool.user && pool?.lpTokenDecimal ? pool.token0Price*parseFloat(ethers.utils.formatUnits(pool.user?.pendingreward, 18).toString()) : 0}
            unit=" USD"
          />
        </> 
        : 
        <CellContent>
          <Text fontSize="12px" color="#00FED9" textAlign="left">
            {labelText}
          </Text>

          <>

            <Flex>
              <Box mr="8px" height="32px">
                {active ?
                  <Balance
                    mt="4px"
                    // display="inline"
                    fontSize={isMobile ? '14px' : '16px'}
                    color="white"
                    decimals={2}
                    prefix=""
                    value={pool.user.pendingreward}
                    unit={` ${pool.name}`}
                  />

                  :

                  <Balance
                    mt="4px"
                    // display="inline"
                    fontSize={isMobile ? '14px' : '16px'}
                    color="white"
                    decimals={2}
                    prefix=""
                    value={0}
                    unit={` ${pool.name}`}
                  />
                }


                <>

                  <Balance
                    display="inline"
                    fontSize="12px"
                    color="#B1B3CB"
                    decimals={2}
                    prefix="~ "
                    value={pool.user.pendingreward*price}
                    unit=" USD"
                  />
                </>

              </Box>
            </Flex>
          </>
        </CellContent>
      }

    </StyledCell>
  )
}

export default AutoEarningsCell
